export const DISCARD_LABEL_CHANGES_MODAL_LABELS = {
	TITLE: 'Discard changes?',
	BODY: 'Any unsaved changes will be lost.',
	DISCARD: 'Discard',
	KEEP_EDITING: 'Keep editing'
} as const;
